/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Marcus Biesel <m.biesel@techdivision.com>
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationDE from '../Config/translationDE.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      de: {
        translation: translationDE,
      },
    },
    lng: 'de', // if you're using a language detector, do not define the lng option
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
